import { Grid, Stack } from '@mui/material'

import { AutoReportDialog, ButtonResetTableFilters, DateRange, ReportDialog } from '@/components'
import { useRequestSbpReport } from '@/services'
import { useAppDispatch, useAppSelector } from '@/stores/hooks.ts'
import { sbpPaymentsActions, sbpPaymentSelectors, SbpTableState } from '@/stores/slices/sbp-payments-slice.ts'
import { SbpPersonalSettings } from '@/pages/sbp-payments/components/sbp-personal-settings.tsx'
import { SbpDebouncedTextField } from '@/pages/sbp-payments/components/sbp-debounced-text-field.tsx'

import { StatusFilter } from './status-filter'
import { TypeFilter } from './type-filter.tsx'

const resettableKeyFilters: (keyof SbpTableState)[] = [
  'operationState',
  'dateTo',
  'dateFrom',
  'requestId',
  'reference',
  'transferState',
]

export const SbpPaymentsFilters = () => {
  const dispatch = useAppDispatch()
  const dateRange = useAppSelector(sbpPaymentSelectors.dateRange)
  const resettableStateFilters = useAppSelector((state) =>
    sbpPaymentSelectors.resettableStateFilters(state, resettableKeyFilters)
  )

  const handleDateChange = (value: [string?, string?]) => {
    dispatch(sbpPaymentsActions.setFilter({ filterKey: 'dateFrom', filterValue: value[0] }))
    dispatch(sbpPaymentsActions.setFilter({ filterKey: 'dateTo', filterValue: value[1] }))
  }

  const resetFilters = () => dispatch(sbpPaymentsActions.resetFilters(resettableKeyFilters))

  return (
    <Stack mb={3} direction="column" gap={4} alignItems="flex-start">
      <Grid container spacing={2} flexDirection="row" alignItems="center" justifyContent="space-between">
        <Grid item xs={10} md={4}>
          <TypeFilter />
        </Grid>
        <Grid
          container
          spacing={2}
          item
          xs={14}
          lg={8}
          justifyContent={{
            xs: 'flex-start',
            lg: 'flex-end',
          }}
        >
          <Grid item>
            <AutoReportDialog kind="SBP" />
          </Grid>
          <Grid item>
            <ReportDialog mutation={useRequestSbpReport()} />
          </Grid>
          <Grid item>
            <SbpPersonalSettings />
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2} flexDirection="row">
        <Grid item xs={12} md={4} lg={2}>
          <StatusFilter />
        </Grid>
        <Grid item xs={12} md={8} lg={5}>
          <DateRange initialRange={dateRange} onChange={handleDateChange} />
        </Grid>
        <Grid item xs={12} md={6} lg={2}>
          <SbpDebouncedTextField />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <ButtonResetTableFilters stateFilters={resettableStateFilters} onResetFilters={resetFilters} />
        </Grid>
      </Grid>
    </Stack>
  )
}
